// Recipient types for submissions (not in Prisma - stored as String?)
export enum RecipientType {
  REGULATORY_AGENCY = "REGULATORY_AGENCY",
  THIRD_PARTY = "THIRD_PARTY",
  INTERNAL = "INTERNAL",
  OTHER = "OTHER",
}
